import { render } from "./sumTable.vue?vue&type=template&id=50a5578c&scoped=true"
import script from "./sumTable.vue?vue&type=script&lang=js"
export * from "./sumTable.vue?vue&type=script&lang=js"

import "./sumTable.vue?vue&type=style&index=0&id=50a5578c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a5578c"]])

export default __exports__